import React, { useEffect, useMemo, useState } from 'react';
import { Carousel, HeaderCarouselDefault, useCarousel } from '@yme/atoms/carousel';
import { GridWrapper } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { CardProduct } from '@yme/molecules/cards';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ProductCarouselSkeleton } from './ProductCarouselSkeleton';
import { CARD_ITEM_SETTINGS, GAP_BETWEEN_ITEMS, GAP_BETWEEN_ITEMS_MOBILE } from './constants';
import { getCarouselData, sortBySlugOrder } from './helpers';
export function ProductCarousel(props) {
    const { isMobileView } = useWindowSize();
    const { title, cards, dataTestId, products, commonParams, daysToShowNew, carouselConfig = CARD_ITEM_SETTINGS, isInEditor, isDataLoaded = true, handleOnClickCarouselItem, isSaleLabelNeeded = true, infoText, } = props;
    const { isRightToLeft, commonLabels, rootLanguage, isInAuthor, pdpLinks } = commonParams;
    const [productData, setProductData] = useState([]);
    const { common_next_label: nextLabel, common_previous_label: prevLabel } = commonLabels;
    const sortedProducts = useMemo(() => {
        if (cards) {
            return sortBySlugOrder(cards, products);
        }
        return products;
    }, [cards, products]);
    const { activeItem, onClickPrevItem, onClickNextItem, indexOfCount, counts, setCounts } = useCarousel();
    const commonProps = {
        titleCarousel: title,
        isRightToLeft,
        activeItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
        counts,
    };
    const arrowTitles = {
        titlePrev: prevLabel,
        titleNext: nextLabel,
    };
    const headerCarouselComponent = (React.createElement(HeaderCarouselDefault, { ...commonProps, arrowTitles: arrowTitles, infoText: infoText, isArrowNavigationVisible: true, isArrowNavigationVisibleOnTablet: true }));
    useEffect(() => {
        setProductData(getCarouselData({
            products: sortedProducts,
            rootLanguage,
            pdpLinks,
            isInAuthor,
            handleOnClickCarouselItem,
            isSaleLabelNeeded,
        }));
    }, [
        products,
        rootLanguage,
        pdpLinks,
        isInAuthor,
        sortedProducts,
        handleOnClickCarouselItem,
        isSaleLabelNeeded,
    ]);
    if (!isDataLoaded && !isInEditor) {
        return React.createElement(ProductCarouselSkeleton, null);
    }
    return (React.createElement(GridWrapper, null,
        React.createElement(FlexWrapper, { overflow: "hidden", flexDirection: "column", isRightToLeft: isRightToLeft },
            headerCarouselComponent,
            React.createElement(Carousel
            // common props for functionality of carousel
            , { ...commonProps, 
                // call component Header Carousel with props
                headerCarousel: headerCarouselComponent, daysToShowNew: daysToShowNew, getterSize: isMobileView ? GAP_BETWEEN_ITEMS_MOBILE : GAP_BETWEEN_ITEMS, items: productData, isDotsPanelVisible: true, ChildComponent: CardProduct, setCounts: setCounts, carouselConfig: carouselConfig, dataTestId: dataTestId }))));
}
